import { render, staticRenderFns } from "./customDropzone.vue?vue&type=template&id=695f40f0&scoped=true"
import script from "./customDropzone.vue?vue&type=script&lang=js"
export * from "./customDropzone.vue?vue&type=script&lang=js"
import style0 from "./customDropzone.vue?vue&type=style&index=0&id=695f40f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695f40f0",
  null
  
)

export default component.exports